export default function Pagination({
  pageSize,
  pageIndex,
  setPageSize,
  gotoPage,
  rowCount,
  extend,
}: any) {
  const firstRowNumber = rowCount ? pageIndex * pageSize + 1 : 0;
  const lastRowNumber = (pageIndex + 1) * pageSize;

  const rangeOfRows = (extend?: boolean) => {
    let range = [];
    range.push(10);
    range.push(25);
    range.push(50);
    range.push(100);
    range.push(500);

    return range;
  };

  return (
    <div className="mb-4 flex text-xs items-center justify-end mt-6">
      <button
        className="border border-slate-200 mr-3 rounded-sm text-xs bg-white px-2 py-1"
        onClick={() => gotoPage(pageIndex - 1)}
      >
        Prev
      </button>
      {firstRowNumber} - {lastRowNumber > rowCount ? rowCount : lastRowNumber}{" "}
      of {rowCount}
      <button
        className="border border-slate-200 rounded-sm text-xs py-1 bg-white ml-4 px-2 mr-11"
        onClick={() => gotoPage(pageIndex + 1)}
      >
        Next
      </button>
      Rows per page
      <select
        className="border border-slate-200 rounded-sm text-xs py-1 bg-white ml-3 px-2"
        onChange={(e) => {
          setPageSize(parseInt(e.target.value, 10));
          gotoPage(0);
        }}
        value={pageSize}
      >
        {rangeOfRows(extend).map((option, i) => (
          <option key={i}>{option}</option>
        ))}
      </select>
    </div>
  );
}
